import { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router-dom";

import DataTable from "react-data-table-component";
import { ChevronDown } from "react-feather";

import { useTokenStatus } from "../../../hooks/useTokenStatus";

import { columns } from "./columns";

import { PATH } from "../../../api/uploadAPI";

const AssetsList = ({ tokens }) => {
    const history = useHistory();
    const { getTokenTotal } = useTokenStatus();
    const [tableData, setTableData] = useState([]);

    const dataToRender = useCallback(() => {
        if (!tokens) {
            return [];
        } else {
            return Promise.all(
                tokens.map(async (token) => {
                    let link = "";
                    if (token.unlockableLink) {
                        link = PATH + "unlock/true/" + token.unlockableLink;
                    }
                    const item = {
                        ...token,
                        link,
                        tokenStats: await getTokenTotal(token._id),
                        onCellClick: (tokenId) =>
                            history.push(`/contracts/token/${tokenId}`),
                    };
                    return item;
                })
            );
        }
    }, [getTokenTotal, history, tokens]);
    useEffect(() => {
        dataToRender().then((res) => setTableData(res));
        return () => {
            setTableData([]);
        };
    }, [tokens, dataToRender]);

    return (
        <div className="react-dataTable">
            <DataTable
                noHeader
                responsive
                columns={columns}
                sortIcon={<ChevronDown />}
                highlightOnHover
                pointerOnHover
                onRowClicked={({ _id }) =>
                    history.push(`/contracts/token/${_id}`)
                }
                className="react-dataTable"
                data={tableData}
            />
        </div>
    );
};

export default AssetsList;
